import axios from 'axios';
import EndPointInfo from '../utility/Endpoints';

const { papiGatewayEndpoint } = EndPointInfo;

const getRequest = async address => axios.get(address,
  {
    headers: {
      'X-API-Key': process.env.REACT_APP_API_GATEWAY_API_KEY,
    },
  });

const getPaymentDetails = async (contactId) => {
  const updatedAddress = `${papiGatewayEndpoint}?contactId=${contactId}`;
  return getRequest(updatedAddress);
};

export default getPaymentDetails;
